import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';

import AccessPermission from 'Component/access-permission';
import DashboardContainer from 'Component/dashboard-container';
import { routeListMobile, routeList } from 'Route/const';
import useIsMobile from 'Hook/useIsMobile';
import { Condition } from 'Component/others';
import MobileContainer from 'Component/mobile-container';
import ErrorPage from 'View/error';
import ForbiddenPage from 'View/forbidden';

const Router = () => {
  const isMobile = useIsMobile();

  return (
    <BrowserRouter>
      <ErrorBoundary fallbackRender={(error) => <ErrorPage error={error} />}>
        <AccessPermission>
          <Condition statement={!isMobile}>
            <DashboardContainer>
              <Routes>
                {routeList?.map(({ path, children }) => (
                  <Route path={path} key={path}>
                    {children?.map((item) => (
                      <Route key={item?.path} path={item?.path} element={item?.element} exact={item?.exact} />
                    ))}
                  </Route>
                ))}
                <Route path="*" element={<ForbiddenPage />} />
              </Routes>
            </DashboardContainer>
          </Condition>

          <Condition statement={isMobile}>
            <MobileContainer>
              <Routes>
                {routeListMobile?.map(({ path, children }) => (
                  <Route path={path} key={path}>
                    {children?.map((item) => (
                      <Route key={item?.path} path={item?.path} element={item?.element} exact={item?.exact} />
                    ))}
                  </Route>
                ))}
                <Route path="*" element={<ForbiddenPage />} />
              </Routes>
            </MobileContainer>
          </Condition>
        </AccessPermission>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Router;
